import React from 'react'
import ExpenseReport, {
  ExpenseReportContext,
} from 'src/app/ExpenseReport/ExpenseReport'

/**
 * Flat-route adapter for the /review/reimbursements/:id manager-review detail
 * entry point.
 *
 * The flat route registry binds a prop-less `ComponentType`, but the legacy
 * `managerReviewReimbursement.appRoute` rendered
 * `<ExpenseReport context={ExpenseReportContext.managerReview} />`. This thin
 * wrapper preserves that exact binding so the manager-review variant of the
 * report is reached on direct load of /review/reimbursements/:id. The report id
 * is still resolved inside ExpenseReport via `selectExpenseReportIdFromRoute`
 * (matchPath over the unchanged route path), so this adapter takes no props.
 */
const ExpenseReportManagerReview: React.FC = () => (
  <ExpenseReport context={ExpenseReportContext.managerReview} />
)

export default ExpenseReportManagerReview
